import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import DataContainer from '../../../../Utilities/DataContainer';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';

//WS-03-A-17
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanMarketingSuite({ isReadOnly }: IProps) {
    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    <DataContainer title={"Marketing Suite Details"}>
                        <Stack spacing={1}>
                            {hasValues(["marketingSuite"]) && (
                                <Grid container size={12}>
                                    <RenderSelectField name="marketingSuite" label="Does the site include an operational Marketing Suite?" readOnly={isReadOnly} options={yesNoDropdown} />
                                </Grid>
                            )}
                            {hasValues(["marketingSuiteInfo", "marketingInfoMonth", "marketingInfoYear"]) && (
                                <Grid container size={12}>
                                    <RenderSelectField name="marketingSuiteInfo" label="If the site has a Marketing Suite, does it include any information on the site's Travel Plan? (for example a display in the Marketing Suite, leaflets, information on the marketing website, etc.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'marketingInfoMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'marketingInfoYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Grid>
                            )}
                        </Stack>
                    </DataContainer>
                </Grid>

                <Grid size={4} container>
                    {hasValues(["marketingTraining", "marketingTrainingMonth", "marketingTrainingYear"]) && (
                        <Grid container size={12}>
                            <DataContainer title={"Marketing Training Details"}>
                                <Stack spacing={1}>
                                    <RenderSelectField name="marketingTraining" label="Are the sales and marketing staff provided with specific training on the site's Travel Plan? (if so, specify what this training consists of and what elements of the Travel Plan are convered.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'marketingTrainingMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'marketingTrainingYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    <Grid container size={12}>
                        <DataContainer title={"Marketing Comments"}>
                            <RenderTextField name="marketingComments" label="Specify details of all Travel Plan elements identified in this section, along with any other marketing suites and sales staff features not already covered." multiLine={true} rows={4} inputSize={12} labelSize={12} readOnly={isReadOnly} alwaysShow={true} />
                        </DataContainer>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
